import { useToggle } from '@hooks/useToggle';
import classNames from 'classnames';
import { Collapse } from 'reactstrap';

export const ConnectionsGroupWrapper = ({ title, children }: { title: React.ReactNode; children: React.ReactNode }) => {
  const [isOpen, toggle] = useToggle(false);
  return (
    <>
      <div className='my-2 d-flex justify-content-between align-items-center cursor-pointer' onClick={toggle}>
        <h6 className='mb-0 mr-1 text-ThemeTextLight'>{title}</h6>
        <i
          className={classNames('fa-light text-ThemeIconSecondary', {
            'fa-caret-up': isOpen,
            'fa-caret-down': !isOpen,
          })}
        ></i>
      </div>
      <Collapse isOpen={isOpen}>{children}</Collapse>
    </>
  );
};